var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex items-center"},[_c('div',{staticClass:"bg-white rounded-full w-full h-full overflow-x-hidden"},[_c('div',{staticClass:"h-full rounded-full relative",class:("bg-" + _vm.color),style:(_vm.style)})])])}
var staticRenderFns = []

export { render, staticRenderFns }